import { FC } from 'react';
import { Button, Modal } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import flagAT from '@/assets/images/flags/at.svg';
import flagFR from '@/assets/images/flags/fr.svg';
import flagIT from '@/assets/images/flags/it.svg';
import flagES from '@/assets/images/flags/es.svg';
import flagTR from '@/assets/images/flags/tr.svg';
import flagGB from '@/assets/images/flags/gb.svg';
import styles from './index.less';
import Track from '@/tracks';

/** Meta 广告附加费适用地区及费率 */
const COUNTRIES: { flag: string; nameKey: string; rate: string }[] = [
  { flag: flagAT, nameKey: 'meta_country_austria', rate: '5%' },
  { flag: flagFR, nameKey: 'meta_country_france', rate: '3%' },
  { flag: flagIT, nameKey: 'meta_country_italy', rate: '3%' },
  { flag: flagES, nameKey: 'meta_country_spain', rate: '3%' },
  { flag: flagTR, nameKey: 'meta_country_turkey', rate: '5%' },
  { flag: flagGB, nameKey: 'meta_country_uk', rate: '2%' },
];

/** 请特别注意 —— 富文本条目（含加粗片段） */
const NOTE_KEYS = [
  'meta_surcharge_note_1',
  'meta_surcharge_note_2',
  'meta_surcharge_note_3',
];

interface MetaSurchargeModalProps {
  open: boolean;
  /** 点击「确认已知悉」或关闭按钮时触发 */
  onClose: () => void;
}

/** Meta 广告附加费重要通知弹窗 */
const MetaSurchargeModal: FC<MetaSurchargeModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      className={styles['meta-surcharge']}
      width={560}
      footer={null}
      centered
      maskClosable={false}
      closable={false}
      zIndex={1100}
    >
      <div className={styles.header}>
        <span className={styles['warning-icon']}>⚠️</span>
        <span className={styles.title}>{t('meta_surcharge_notice_title')}</span>
      </div>

      <p className={styles.subtitle}>
        <Trans
          i18nKey="meta_surcharge_notice_subtitle"
          components={{ b: <b /> }}
        />
      </p>

      <div className={styles['section-title']}>
        {t('meta_surcharge_applicable_markets')}
      </div>
      <div className={styles.countries}>
        {COUNTRIES.map((item) => (
          <div className={styles.country} key={item.nameKey}>
            <img className={styles.flag} src={item.flag} alt={t(item.nameKey)} />
            <span className={styles['country-name']}>{t(item.nameKey)}</span>
            <span className={styles.rate}>{item.rate}</span>
          </div>
        ))}
      </div>

      <div className={styles.notes}>
        <div className={styles['notes-header']}>
          <span className={styles['info-icon']}>i</span>
          {t('meta_surcharge_please_note')}
        </div>
        <ul className={styles['notes-list']}>
          {NOTE_KEYS.map((key, index) => (
            <li className={styles['notes-item']} key={key}>
              <span className={styles['notes-index']}>{index + 1}</span>
              <span className={styles['notes-text']}>
                <Trans i18nKey={key} components={{ b: <b /> }} />
              </span>
            </li>
          ))}
        </ul>
      </div>

      <p className={styles['footer-note']}>{t('meta_surcharge_footer_note')}</p>

      <div className={styles['footer-btn']}>
        <Button type="primary" block size="large" onClick={() => {
          Track.track('「确认已知悉」Meta税费政策通知');
          onClose?.()
        }}>
          {t('meta_surcharge_acknowledge')}
        </Button>
      </div>
    </Modal>
  );
};

export default MetaSurchargeModal;
